<template>
  <div>
    <tables class="overflow-hidden">
      <template #tableBody>
        <tbody class="bg-white">
          <tr
            v-for="(product, index) in order.customerOrderLines"
            :key="index"
            :class="[
              (showReOrder && getVisibilityStatus() && !patientDeceasedStatus) || !order.isEquipmentOrder
                ? index === order.customerOrderLines.length - 1 && order.customerOrderLines.length > 1
                  ? 'border-y border-balternative-color'
                  : 'border-t border-balternative-color'
                : 'border-x border-t border-balternative-color',
              product.orderLineStatus === 'Cancelled' ? 'line-through opacity-25' : ''
            ]"
          >
            <td class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-tdefault-color w-1/12">
              <div class="flex items-center justify-start mr-2 text-left min-h-20 min-w-20">
                <img
                  :src="getImageUrl(product.imageUrl)"
                  @error="handleImageError"
                  class="max-h-20 max-w-20 mx-auto"
                  :alt="product.name ? `Image of ${product.name}` : 'Product image'"
                />
              </div>
            </td>
            <td
              class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-tdefault-colo w-7/12 cursor-pointer"
              @click.prevent="goToProductDetailPage(product.baseProductId)"
            >
              <div class="font-bold">{{ $toTitleCase(product.name) }}</div>
            </td>
            <td class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-tdefault-color w-2/12">
              <span class="font-bold">Aantal: </span>{{ product.quantity }}
            </td>
            <td class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-tdefault-color w-2/12 text-end">
              <span class="font-bold">Artikelcode: </span> {{ product.productCode }}
            </td>
          </tr>
        </tbody>
      </template>
    </tables>
    <div class="flex items-center justify-between w-full">
      <div class="" v-if="orderVisibility === 'PartiallyVisible'">
        <Alert
          :html="true"
          htmlMessage="Om privacyredenen is de volledige order niet zichtbaar.
                          <p class=''>Vraag toestemming aan de patiënt voor het delen van patiëntgegevens en bevestig dit in het portaal. <a href='https://mediq.nl/over-ons/privacy' target='_blank' class='underline cursor-pointer'> Lees hier meer over het delen van patiëntgegevens.</a></p>"
          type="alert"
        ></Alert>
      </div>
      <div v-if="!isArchived" class="ml-auto">
        <button
          v-if="showReOrder && getVisibilityStatus() && !patientDeceasedStatus && order.type !== 'Herhaalservice'"
          @click.prevent="reOrder"
          class="flex justify-center py-2 px-2 md:px-4 border border-primary-default shadow-sm text-sm font-medium text-white bg-primary-default rounded-full hover:bg-primary-default/50 items-center my-8 mx-4 justify-self-end"
        >
          Bestelling herhalen
        </button>
        <div v-else-if="!order.isEquipmentOrder && order.type !== 'Herhaalservice'" class="my-8 mx-4 justify-self-end">
          Opnieuw bestellen niet mogelijk. Niet bestelbaar
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';
import { shoppingCart$, addToShoppingCart, activePpwRecId$ } from '@/services';
import { ref } from 'vue';

export default {
  name: 'OrderHistoryEntryProducts',
  components: {},
  props: {
    showReOrder: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object
    },
    patientDeceasedStatus: {
      type: Boolean,
      default: false
    },
    isArchived: {
      default: false,
      type: Boolean
    }
  },
  setup(props) {
    const shoppingCart = ref(null);
    const activePpwRecId = ref(null);

    shoppingCart$.subscribe((value) => (shoppingCart.value = value));
    activePpwRecId$.subscribe((value) => (activePpwRecId.value = value));

    const reOrder = () => {
      props.order.customerOrderLines.forEach((product) => {
        addToShoppingCart(shoppingCart.value, product.productId, product.quantity, activePpwRecId.value);
      });
      router.push('/bestellijst');
    };

    const goToProductDetailPage = (baseProductId) => {
      if (!baseProductId) return;
      router.push('/catalog/baseProduct/' + baseProductId);
    };

    const getVisibilityStatus = () => {
      let status = true;
      for (let i = 0; i < props.order.customerOrderLines.length; i++) {
        if (!props.order.customerOrderLines[i].orderable) {
          status = false;
          break;
        }
      }
      return status;
    };

    const orderVisibility = props.order.orderVisibility;

    return {
      shoppingCart,
      activePpwRecId,
      reOrder,
      getVisibilityStatus,
      goToProductDetailPage,
      orderVisibility
    };
  }
};
</script>
